import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ReimbursementService } from '../reimbursement.service';
import { ExpenseItems } from '../reimbursement.interfaces';
import { Router } from '@angular/router';
import { FlashService } from '../../flash/flash.service';
import { ListDepartments } from '../reimbursement.interfaces';
import { INgxMyDpOptions } from 'ngx-mydatepicker';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { FormBuilder, FormGroup, ValidatorFn, ValidationErrors, Validators, FormControl } from '@angular/forms';

@Component({
  selector: 'app-reimbursement-admin-list',
  templateUrl: './reimbursement-admin-list.component.html',
  styleUrls: ['./reimbursement-admin-list.component.css']
})
export class ReimbursementAdminListComponent implements OnInit {
  currentPageNo = 1;
  total;
  perpage;
  noData = false;
  adminList: ExpenseItems[];
  user;
  reimbursement_manager;
  accepted;
  status: ListDepartments[];

  emp_Id;
  status_Id = "";
  filterDate;
  dateForm: FormGroup;
  myOptions: INgxMyDpOptions = {
    dateFormat: 'yyyy-mm-dd'
  };
  constructor(private reimbur: ReimbursementService, private formBuilder: FormBuilder,
    public router: Router, private flashService: FlashService, private spinnerService: Ng4LoadingSpinnerService,
  ) {
    this.reimbur.getListStatus().subscribe(data => {
      this.status = data;
    });
  }

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('currentUser'));
    this.user.roles.forEach(roles => {
      if (roles == 'reimbursement_manager') {
        this.reimbursement_manager = roles;
      }
    });

    this.reimbur.getListStatus().subscribe(status => {
      status.filter(status => {
        if (status.key === "paid") {
          this.accepted = status.key;
        }
      });
    });

    this.dateForm = this.formBuilder.group({
      'from_date': ['', Validators.required],
      'to_date': ['', Validators.required]
    }, { validator: this.checkDates('from_date', 'to_date') });

    this.getAdminList();

  }

  public checkDates(startKey: string,
    endKey: string): ValidatorFn {
    return (group: FormGroup): ValidationErrors => {
      const startDate = group.controls[startKey];
      const endDate = group.controls[endKey];
      if (startDate.value !== '' && endDate.value !== '') {
        startDate.setErrors(null);
        endDate.setErrors(null);
        const d_startDate = new Date(startDate.value.formatted);
        const d_endDate = new Date(endDate.value.formatted);
        let startValid = true;
        let endValid = true;
        const d_currentDate = new Date();
        if (startDate.value !== '') {
          if (d_startDate > d_currentDate) {
            startDate.setErrors({ 'type': 'startDateLess', 'message': 'Start Date should be less than Current Date.' });
            startValid = false;
          }
        }
        if (endDate.value !== '') {
          if (d_endDate > d_currentDate) {
            endDate.setErrors({ 'type': 'endtDateLess', 'message': 'End Date should be less than Current Date.' });
            endValid = false;
          }
        }
        if (startDate.value !== '' && endDate.value !== '' && startValid && endValid) {
          if (d_startDate > d_endDate) {
            startDate.setErrors({ 'type': 'startDateLess', 'message': 'Start Date should be less than End Date.' });
            endDate.setErrors({ 'type': 'startDateLess', 'message': 'End Date should be greater than Start Date.' });
          }
        }
      }
      return;
    };
  }


  managerAccept(id, list) {
    let final = {
      items: []
    }
    list.items.forEach(itemsData => {
      const itemsPayload = {
        _id: itemsData._id,
        approval_cost: itemsData.cost
      }
      final.items.push(itemsPayload);
    });
    this.spinnerService.show();
    this.reimbur.getAccept(final, id, this.accepted).subscribe(accepted => {
      this.spinnerService.hide();
      if (accepted['message']) {
        this.getAdminList();
        this.flashService.show(accepted['message'], 'alert-success');
      }
    }, error => {
      this.spinnerService.hide();
    });
  }

  trackByFn(index) {
    return index;
  }
  getAdminList(pgNo?) {
    if (pgNo != null) {
      this.currentPageNo = pgNo;
    }
    this.filterDate = '';

    if (this.dateForm.valid && this.dateForm.controls.from_date.value && this.dateForm.controls.to_date.value) {
      this.filterDate = `&from_date=${this.dateToString(this.dateForm.controls.from_date.value)}&to_date=${this.dateToString(this.dateForm.controls.to_date.value)}`
    }

    this.reimbur.getAdminList(this.currentPageNo, this.filterDate, this.emp_Id, this.status_Id).subscribe(data => {
      this.total = data.totalcount;
      this.perpage = data.perpage;
      this.adminList = data['reimbursement'];
      if (data['reimbursement'].length === 0) {
        this.noData = true;
      } else {
        this.noData = false;
      }
    });
  }

  removeToDate(event) {
    event.preventDefault();
    this.dateForm.reset();
  }

  removedate(event) {
    event.preventDefault();
    this.dateForm.reset();
  }

  dateToString(value) {
    if (value && value != undefined) {
      const dateString = value.date.year + '-' +
        (value.date.month < 9 ? '0' : '') + value.date.month + '-' +
        (value.date.day < 10 ? '0' : '') + value.date.day;
      return dateString;
    }
  }
  itemsList(id, list) {
    this.reimbur.reimbursementUserList = list;
    this.router.navigate(['/reimbursement/admin/view', id]);
  }

  fileDownload(reimbur_id) {
    this.reimbur.getReportFile(reimbur_id).subscribe((blob: Blob) => {
      const fileName = "report.pdf";
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fileName);
      }
      else {
        let link = document.createElement("a");
        if (link.download !== undefined) {
          let url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    });
  }

  fileDownloadPaid(reimbur_id) {
    this.reimbur.getReport(reimbur_id).subscribe((blob: Blob) => {
      const fileName = "report.pdf";
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fileName);
      }
      else {
        let link = document.createElement("a");
        if (link.download !== undefined) {
          let url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    });
  }

  downloadReport() {
    if (this.dateForm) {
      if (this.dateForm.controls.from_date.value != undefined || this.dateForm.controls.to_date.value != undefined) {
        this.filterDate = `&from_date=${this.dateToString(this.dateForm.controls.from_date.value)}&to_date=${this.dateToString(this.dateForm.controls.to_date.value)}`

      }
    }
    this.reimbur.getExportCsv(this.filterDate).subscribe((blob: Blob) => {
      const fileName = "report.csv";
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fileName);
      }
      else {
        let link = document.createElement("a");
        if (link.download !== undefined) {
          let url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    })
  }

}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/reimbursement/reimbursement-admin-list/reimbursement-admin-list.component.ts